import { styled } from "@mui/material/styles";
import { TextField, FormControl, Button, Paper, Box } from "@mui/material";

export const StyledTextField = styled(TextField)(({ theme }) => ({
	marginBottom: theme.spacing(2),
	"& .MuiOutlinedInput-root": {
		borderRadius: "4px",
		"& fieldset": {
			borderColor: "#e0e0e0",
		},
		"&:hover fieldset": {
			borderColor: "#e0e0e0",
		},
		"&.Mui-focused fieldset": {
			borderColor: "#A56825",
		},
	},
	"& .MuiInputLabel-root": {
		color: "#B9B9B9",
	},
	"& .MuiInputLabel-root.Mui-focused": {
		color: "#A56825",
	},
}));

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
	marginBottom: theme.spacing(2),
	"& .MuiOutlinedInput-root": {
		borderRadius: "4px",
		"& fieldset": {
			borderColor: "#e0e0e0",
		},
		"&:hover fieldset": {
			borderColor: "#e0e0e0",
		},
		"&.Mui-focused fieldset": {
			borderColor: "#A56825",
		},
	},
	"& .MuiInputLabel-root": {
		color: "#B9B9B9",
	},
	"& .MuiInputLabel-root.Mui-focused": {
		color: "#A56825",
	},
}));

export const FormContainer = styled(Paper)(({ theme }) => ({
	padding: theme.spacing(3),
	borderRadius: "8px",
	backgroundColor: "#ffffff",
	width: "95%",
	margin: "0 auto",
	[theme.breakpoints.down("sm")]: {
		padding: theme.spacing(2),
	},
	"& .form-content": {
		border: "2px solid #d3a260",
		padding: theme.spacing(3),
		borderRadius: "10px",
		[theme.breakpoints.down("sm")]: {
			padding: theme.spacing(2),
		},
	},
	"& .MuiBox-root.css-55jbfs": {
		height: "auto !important",
	},
}));

export const FormGrid = styled(Box)(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "repeat(2, 1fr)",
	gap: theme.spacing(2),
	[theme.breakpoints.down("md")]: {
		gridTemplateColumns: "1fr",
	},
}));

export const StyledButton = styled(Button)(({ theme }) => ({
	backgroundColor: "#C47D2D",
	color: "white",
	padding: "10px 0",
	marginTop: theme.spacing(3),
	marginBottom: theme.spacing(1),
	"&:hover": {
		backgroundColor: "#A56825",
	},
	width: "100%",
	maxWidth: "200px",
	display: "block",
	margin: "20px auto 0",
	fontFamily: "Roboto",
	fontWeight: 700,
	fontSize: "14px",
	lineHeight: "100%",
	letterSpacing: "0%",
}));
